import {RefundForm} from '@/plugins/api'
import get from 'lodash/get'

export default {
  namespaced: true,
  state: {
    form: {}
  },
  actions: {
    async fetchRefundForm({commit}, {cv}) {
      const res = await RefundForm.fetch({cv})
      const form = get(res, '0', {})
      commit('changeState', {form: get(res, '0', {})})
      return form
    },
    createForm(_, data) {
      return RefundForm.create(data)
    }
  },
  mutations: {},
  getters: {
    form: state => state.form
  }
}
